import React, {useState, useEffect} from 'react';
import propTypes from 'prop-types';
import { get, findIndex } from 'lodash';
import Text from '../../typography'
import styled from '@emotion/styled';
import {Cta} from '../../ui';
import {theme} from '../../../themes/default-theme';
import qs from 'qs';
import {Grid, Box, ButtonBase} from '@mui/material';
import { makeStyles } from '@mui/styles';
import TabsCurved from '../../ui/TabsCurved';
const Wrapper = styled.div`  
  h3 {
    font-weight:800;
  }
  ${props => props.backgroundColor === 'black' ? `
      background:${theme.palette.shadeBlack};
      table {
        background:${theme.palette.shadeBlack} !important;
        td {
          background:#292929 !important;
          border-color:#0a0a0a !important;
        }
        th {
          color:${theme.palette.white} !important;
        }
        span.optional {
          background:#0a0a0a !important;
        }
      }
      h3, p, li, ul, ol, div {   
        color:${theme.palette.white} !important;
      }
    `
    : `      
      background:${theme.palette.lightGrey};
    `
  };
`

const Container = styled.div`  
  max-width:1220px;
  margin:auto;
  padding: 60px 55px;
  ${theme.breakpoints.down("sm")} {
    padding: 60px 0;
  }
`
const TabsContainer = styled.div`
    margin-top: 20px;
    ${theme.breakpoints.up("md")} {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 30px;
        margin-bottom: 20px;
    }
`

const TabItem = styled.div`
    ${theme.breakpoints.up("md")} {
        padding: 0 20px 20px;
        min-width: 410px;
    }
    ${theme.breakpoints.down("sm")} {
        margin-bottom: 20px;
        div {
            padding-right: 0;
        }
        .MuiTabs-flexContainer {
            padding-top: 11px;
            text-align: center;
        }
        label {
            padding-left: 8px!important;
            padding-right: 21px!important;
        }
        button {
            position: relative;
            width: auto;
            // line-height: 0;
            padding: 6px 8px; 
            + div {
                position: relative;
                min-width: 85px;
                width: auto;
                display: grid;
                line-height: 0;
                background: ${theme.palette.white};
                label + div {
                    background: ${theme.palette.white};
                    min-width: auto;
                    button {
                        right: auto;
                    }
                }
            }
        }
    }
    ${theme.breakpoints.down("400")} {
        ${props => props.activeMobileLength == 1 &&  `
            display: flex;
            flex-direction: column;
            align-items: center;
            .MuiTabs-flexContainer {
                overflow-x: auto!important;
                display: -webkit-box;
                display: ruby-text;
            }
        `}  
    }
    > div, > div > div, button, button + div {
        overflow: visible!important;
        // background: ${theme.palette.white};
    }
    p {
        margin-top: 0;
        ${theme.breakpoints.up("md")} {
            margin-bottom: 14px;
        }
         ${theme.breakpoints.down("sm")} {
            margin-bottom: 0;
        }
    }
`

const CustomBox = styled(Box)`
  ${theme.breakpoints.down("sm")} {
    padding: 0;
  }
`

const IndicatorCTAs = styled.div`  
  width:100%;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  align-items:center;
  gap:20px;
  margin-top:30px;
  padding-left:0;
    a {
    display:inline-block;
    width:auto;
    margin-left:20px;
    ${theme.breakpoints.down('md')}{
      margin-bottom: 12px;
      margin-left: 10px;
      margin-right: 10px;
    }
    
  }  
  ${theme.breakpoints.up("md")} {
    margin-top:40px;
    flex-direction:row;
  }
  ul {
    list-style:none;
    margin:0;
    ${theme.breakpoints.up('md')}{
      padding-left: 0!important;
      padding:0;
    }
    ${theme.breakpoints.down('sm')}{
          display: flex;
          gap: 18px;
          padding: 0 16px;
      }
    li {
      display:inline-block;
      font-size:14px;
      line-height:23px;    
      margin-bottom:0;
      margin-right:50px; 
      padding-left: 20px;
      &:first-child {
        &:before {
          width:12px;
          height:12px;
          border-radius:50%;
          background-color:${theme.palette.vividBlue};
          top:6px !important;
          content:"" !important;
        }
      }
      &:nth-child(2) {
        &:before {
          width:13px;
          height:13px;          
          border:2px solid ${theme.palette.vividBlue};
          border-radius:50%;
          top:6px !important;
          content:"" !important;
          ${props => props.backgroundColor === 'black' ? `
            background:#0a0a0a;
          `:`
            background:${theme.palette.white};
          `}; 
        }
      }
      &:last-child {
        &:before {
          content:"" !important;
          width:12px;
          height:3px;
          background:${theme.palette.vividBlue};
        }
      }
      &:before {
        left: 0 !important;
      } 

      ${theme.breakpoints.down('md')}{
        &:not(:first-child) {
          margin-left: 25px;          
        }
        margin-right: 15px;
        ${props => props.backgroundColor === 'black' ? `
          color:${theme.palette.white};
        `  
        : `
          color:${theme.palette.charcoal};
        `}; 
      }
      ${theme.breakpoints.down('sm')}{
        font-size: 12px;
        &:not(:first-child) {
          margin-left: 0;          
        }
        margin-right: 0;
        
      }
  }
`

const TableContainer = styled.div`  
  padding-top:30px;
  table {
    background:${theme.palette.white};
    width:100%;
    td {
      background:#f9f9fb;
      font-size:14px;
      line-height:17px;
      padding:12px 10px; 
      vertical-algin:middle;
      border: 1px solid ${theme.palette.lightGrey};
      text-align:center;
      &:first-child {
        text-align:left;
      }
    }
    th {
      vertical-algin:middle;
      text-align:center;
      padding:5px 10px;
      padding-top:25px;
      opacity:0;
      ${theme.breakpoints.down('md')}{
        // &:not(:first-child) {
        //   display: none;
        // }
      }
      p {
        color:${theme.palette.charcoal};
        &:first-child {
          font-size:14px;
          line-height:18px; 
          text-transform:uppercase;
          margin:0;
          padding:0 0 2px 0;
        }
        &:last-child {
          font-size:13px;
          margin-top:0;
          padding-top:0;
          margin-bottom:0;
          padding-bottom:0;
          line-height:18px; 
        }
      }
      &:first-child {
        opacity:1;
        width:70%;
        font-weight: 800;
        font-size:18px;
        line-height:24px;
        text-transform:uppercase;
        color:${theme.palette.charcoal};
        text-align:left;
      }
    }
    &:first-child {
      th {
        opacity:1;
      }
    }
  }

  span {
    display:inline-block;
    margin:auto;
    &.standard {    
      width:12px;
      height:12px;
      border-radius:50%;
      background-color:${theme.palette.vividBlue};
    } 
    &.optional {
      width:13px;
      height:13px;
      border-radius:50%;
      background:${theme.palette.white};
      border:2px solid ${theme.palette.vividBlue};
    }
    &.na {
      width:12px;
      height:3px;
      background:${theme.palette.vividBlue};
    }
  }
`

const Hr = styled.hr`

    border-top: 1px solid ${theme.palette.middleGrey};
    border-bottom: 0;
    border-left: 0;
    border-right: 0;

    ${props => props.medium && `
        ${theme.breakpoints.down('sm')} {
            display: none;
        }
    `}

`

const specsTableMotorisedDefaultPropModels = [];
const specsTableMotorisedDefaultPropCtas = [];

const SpecsTableMotorised = ({
  background = null,
  title = null, 
  models = specsTableMotorisedDefaultPropModels,
  selectedModel = null,
  selectedFloorplan = null,
  ctas = specsTableMotorisedDefaultPropCtas,
  uri,
  seriesId,
  rangeId
}) => {

  const [activeModel, setActiveModel] = useState( models?.length > 0 && models.filter((item) => item?.name?.toLowerCase() == selectedModel).length > 0 && selectedModel ? 
      models.filter((item) => item?.name?.toLowerCase() == selectedModel)[0] 
    : models?.length > 0 && models[0]);

  const [activeModelIndex, setActiveModelIndex] = useState(
    selectedModel && models?.length > 0 && models.filter((item) => item?.name?.toLowerCase() == selectedModel).length > 0 && findIndex(models, (i) => i.name.toLowerCase() === selectedModel) ? 
      findIndex(models, (i) => i.name.toLowerCase() === selectedModel) 
    : 0
  );
  const [floorplan, setFloorplan] = useState( 
    models.filter((item) => item?.name?.toLowerCase() == selectedModel).length > 0 && selectedModel && selectedFloorplan && models.filter((item) => item?.name?.toLowerCase() == selectedModel)[0].floorplans.filter((item) => item.name?.toLowerCase() == selectedFloorplan).length > 0 ? 
      models.filter((item) => item?.name?.toLowerCase() == selectedModel)[0].floorplans.filter((item) => item.name?.toLowerCase() == selectedFloorplan)[0] 
    : models?.length > 0 && selectedModel && models.filter((item) => item?.name?.toLowerCase() == selectedModel).length > 0 ? 
      models.filter((item) => item?.name?.toLowerCase() == selectedModel)[0].floorplans[0] 
    : models?.length > 0 && models[0].floorplans[0]
  );
  const [activeFloorplanIndex, setActiveFloorplanIndex] = useState(
    activeModel && models.length > 0 && selectedFloorplan && activeModel.floorplans.filter((item) => item.name?.toLowerCase() == selectedFloorplan).length > 0 ?
      findIndex(activeModel.floorplans, (i) => i.name.toLowerCase() === selectedFloorplan)
      : 0
  );

  const mainFontColour = (background === 'white' || background === 'grey') ? 'charcoal' : 'white';

  console.log('background', background)
  const specPdfUrl = uri && models ? `${uri}/spec-pdf-form?models=${models.map(item => item.id).join(',')}` : null
  const compareData = models.map(item => {
    const modelId = item.id;
    return modelId ? {
      range: rangeId,
      series: seriesId,
      model: modelId,
    } : {
      range: rangeId,
      series: seriesId
    }
  })

  console.log('activeModel', selectedModel)
  console.log('floorplan', selectedFloorplan)

  const param = qs.stringify({items: compareData});
  const compareUrl = `/compare?${param}`

  // const IOS = /iPhone|iPod/.test(navigator.userAgent)
  console.log('specPdfUrl', models, specPdfUrl, param);

  return (
    <Wrapper backgroundColor={background}>    
    <Container>
        {title &&
          <Box px={2}>
            <Text variant="h3" uppercase="true" weight={800} align="center" colour="charcoal">{title}</Text>
          </Box>
        }
      <Box px={2}>
            <TabsContainer>
            
                {(models && models.length > 1) &&
                    <TabItem activeMobileLength={models.length > 3 ? 1 : 0} >
                        <Text variant="body1" colour={mainFontColour} align="center"><p>Select a model</p></Text>
                        <TabsCurved 
                            variant='standard'
                            background={background}
                            activeIndex={activeModelIndex}
                            activeMobileLength={2}
                            data={models.map(item => {
                                return {
                                    ...item,
                                    title: item.name
                                }
                            })}
                            neverNative={true}
                            onChange={(e, item) => {
                                // setActiveFloorplan(floorplans[e])
                                // if (activeModel.floorplans.length !== models[e].floorplans.length && !activeModel.floorplans[e].floorplan)

                                // if model has different number of floorplans, get the closest one (only should apply to last)
                                const curFloorplanIndex = findIndex(activeModel.floorplans, (i) => i.name === floorplan.name);
                                // const newFloorplanIndex = findIndex(models[e].floorplans, (i) => i.floorplanId === floorplan.floorplanId);

                                if (!models[e].floorplans[curFloorplanIndex]) {
                                    const lastIndex = models[e].floorplans.length - 1;
                                    setActiveFloorplanIndex(lastIndex);
                                    setFloorplan(models[e].floorplans[lastIndex]);
                                } else {
                                    setFloorplan(models[e].floorplans[curFloorplanIndex]);
                                }
                                setActiveModelIndex(e);
                                setActiveModel(models[e]);
                            }}
                            // background={background}
                        />
                    </TabItem>
                }
                {(activeModel.floorplans && activeModel.floorplans.length > 0) &&
                
                        <TabItem activeMobileLength={models.length > 3 ? 1 : 0} >
                            <Text variant="body1" colour={mainFontColour} align="center"><p>Select a floorplan</p></Text>
                            <TabsCurved 
                                background={background}
                                variant='standard'
                                activeIndex={activeFloorplanIndex}
                                activeMobileLength={2}
                                neverNative={true}
                                data={activeModel.floorplans.map(item => {
                                    return {
                                        ...item,
                                        title: item.name
                                    }
                                })}                                    
                                onChange={(e, item) => {
                                    console.log('activeModel', activeModel, e, item);
                                    setActiveFloorplanIndex(e);
                                    setFloorplan(activeModel.floorplans[e]);
                                }}
                                // background={background}
                            />
                        </TabItem>
                    
                }
            </TabsContainer>
        </Box>

                <Box px={2}>
                    <Hr />
                </Box>
  
        <CustomBox px={2}>
          <IndicatorCTAs backgroundColor={background}>
            <div>
                <ul>
                  <li>Standard</li>
                  <li>Optional</li>
                  <li>Not Available</li>
                </ul>
            </div>
            <div>
            <Cta primary href={compareUrl} target="_blank">
              Compare Models
              </Cta>
            {(specPdfUrl) &&
              <Cta primary href={specPdfUrl} target="_blank">
                Download Spec Sheet
              </Cta>
            }
              {/* {ctas &&
                ctas.map((item, index) => {
                  return(
                    <Cta primary href={item.href || '#'}>
                      {item.title}
                    </Cta>
                  )
                })} */}
            </div>
          </IndicatorCTAs>
          <TableContainer>
          {floorplan?.sections.length > 0 &&
                floorplan.sections.map(function(item, index) {
                  return (
                    <table cellspacing='0' cellpadding=''>
                      <tr>
                        <th>
                          {item.title}
                        </th>
                  
                            <th>
                              <p>{activeModel.name} Platform</p>
                            </th>
                          
                      
                      </tr>
                      {item.features.map(function(column, index) {
                          return (
                            <tr>
                              <td>{column.title}</td>
                        
                                  <td>
                                    <span className={column.value != 'text' && column.value && column.value}>
                                      {column.value != 'standard' && column.value != 'optional' && column.value != 'na' && column.value && column.value}
                                    </span>
                                  </td>
                                
                            </tr>
                          )
                        })}                      
                    </table>
                  )
              })}
          </TableContainer>
        </CustomBox>
    </Container>
  </Wrapper>
  )
}

SpecsTableMotorised.propTypes = {
  background: propTypes.string,
  title: propTypes.string,
  models: propTypes.array,
  ctas: propTypes.array,
  selectedModel: propTypes.object,
  selectedFloorplan: propTypes.object
}

export default SpecsTableMotorised